export enum AppEnvironment {
  PRODUCTION = "production",
  DEVELOPMENT = "development",
}
